export default __webpack_public_path__ + "static/media/contact-form-image-01.10305dde.png";